export default __webpack_public_path__ + "e6678affb144676ab7430c1710dfab6f.svg";